/**
 * Persists which tenant a super admin has entered (RPAA-213), so the
 * request interceptor (outside React) and AuthContext (inside React) agree
 * on the same value across a page reload.
 */

export const STORAGE_KEY = "entered_tenant";

export const tenantEntryStorage = {
  get() {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    try {
      return JSON.parse(raw);
    } catch {
      return null;
    }
  },

  set(tenant) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(tenant));
  },

  clear() {
    localStorage.removeItem(STORAGE_KEY);
  },
};
